/* eslint-disable react/prop-types */
import {
  Button,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { LinkOff as LinkOffIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

function UnlinkHazardDialog({ open, onClose, onConfirm, hazard }) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: theme.palette.checklist.surface.subtle,
          borderBottom: 1,
          borderColor: theme.palette.checklist.border.subtle,
          pb: 2,
          pt: 3,
          px: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              bgcolor: "warning.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "warning.contrastText",
            }}
          >
            <LinkOffIcon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
              {t("hazards.unlinkConfirmTitle")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("hazards.unlinkConfirmSubtitle")}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{ p: 3, bgcolor: theme.palette.checklist.surface.elevated }}
      >
        <Typography variant="body1" sx={{ mb: 2 }}>
          {t("hazards.unlinkConfirmMessage", {
            hazardName: hazard?.name,
          })}
        </Typography>
        <Box
          sx={{
            p: 2,
            bgcolor: theme.palette.checklist.surface.subtle,
            borderRadius: 1,
            border: 1,
            borderColor: "warning.light",
          }}
        >
          <Typography
            variant="body2"
            color="warning.main"
            sx={{ fontWeight: "medium" }}
          >
            ⚠️ {t("hazards.unlinkConfirmNote")}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          gap: 2,
          bgcolor: theme.palette.checklist.surface.elevated,
          borderTop: 1,
          borderColor: theme.palette.checklist.border.subtle,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: "none",
            fontWeight: "medium",
          }}
        >
          {t("hazards.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="warning"
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: "none",
            fontWeight: "bold",
            boxShadow: 2,
            "&:hover": {
              boxShadow: 4,
              transform: "translateY(-1px)",
            },
          }}
        >
          {t("hazards.unlinkConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnlinkHazardDialog;
